import AXIOS from "./axios";
import { format, parse } from "date-fns";

export class Speciality {
  static all() {
    return AXIOS.get("medical_specialties");
  }
  static mostRequested() {
    return AXIOS.get("medical_specialties/most_requested");
  }
  static async byUnit(unitId) {
    return AXIOS.get(`medical_specialties?unit_id=${unitId}`);
  }
}
